import { render, staticRenderFns } from "./directlyList.vue?vue&type=template&id=636b107e&scoped=true"
import script from "./directlyList.vue?vue&type=script&lang=js"
export * from "./directlyList.vue?vue&type=script&lang=js"
import style0 from "./directlyList.vue?vue&type=style&index=0&id=636b107e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b107e",
  null
  
)

export default component.exports